// extracted by mini-css-extract-plugin
export default {"form":"DomainMonitorFiltersForm_form__RxaPp"};